import apiClient from '../../../services/apiClient';
import { API_ENDPOINTS } from '../../../config/api';

export interface Review {
  _id: string;
  userId: string;
  userName: string;
  userAvatar?: string;
  rating: number;
  text: string;
  socialLinks?: SocialLinks;
  socialEmbedUrl?: string;
  status: 'pending' | 'approved' | 'rejected';
  createdAt: string;
  updatedAt: string;
}

export interface SocialLinks {
  linkedin?: string;
  twitter?: string;
  facebook?: string;
  instagram?: string;
  github?: string;
  website?: string;
}

export interface ReviewStats {
  averageRating: number;
  totalReviews: number;
  ratingDistribution: Record<number, number>;
}

export interface ReviewListParams {
  page?: number;
  limit?: number;
}

export interface ReviewListResponse {
  reviews: Review[];
  total: number;
  page: number;
  totalPages: number;
}

export interface SubmitReviewData {
  rating: number;
  text: string;
  socialLinks?: SocialLinks;
  socialEmbedUrl?: string;
  userName?: string;
  userAvatarUrl?: string;
}

export const fetchApprovedReviews = async (
  params?: ReviewListParams
): Promise<ReviewListResponse> => {
  const response = await apiClient.get(API_ENDPOINTS.REVIEWS_APPROVED, {
    params,
  });
  return response.data;
};

export const fetchReviewStats = async (): Promise<ReviewStats> => {
  const response = await apiClient.get(API_ENDPOINTS.REVIEWS_STATS);
  return response.data;
};

export const submitReview = async (
  data: SubmitReviewData
): Promise<Review> => {
  const response = await apiClient.post(API_ENDPOINTS.REVIEWS_SUBMIT, data);
  return response.data;
};

export const fetchMyReviews = async (): Promise<Review[]> => {
  const response = await apiClient.get(API_ENDPOINTS.REVIEWS_MINE);
  return response.data;
};

export const updateReview = async (
  id: string,
  data: Partial<SubmitReviewData>
): Promise<Review> => {
  const response = await apiClient.put(
    `${API_ENDPOINTS.REVIEWS_SUBMIT}/${id}`,
    data
  );
  return response.data;
};

export const deleteReview = async (id: string): Promise<void> => {
  await apiClient.delete(`${API_ENDPOINTS.REVIEWS_SUBMIT}/${id}`);
};
